import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/job/${':jobId' | number}`;

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}`;
